var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6672 11.0635L7.98685 0.383412C7.73983 0.136194 7.41008 0 7.05847 0C6.70686 0 6.37711 0.136194 6.13009 0.383412L5.34356 1.16975C4.83176 1.68213 4.83176 2.51491 5.34356 3.02651L14.3121 11.995L5.33361 20.9735C5.08658 21.2207 4.9502 21.5503 4.9502 21.9017C4.9502 22.2535 5.08658 22.583 5.33361 22.8305L6.12014 23.6166C6.36735 23.8638 6.69691 24 7.04852 24C7.40013 24 7.72988 23.8638 7.9769 23.6166L18.6672 12.9267C18.9148 12.6787 19.0508 12.3476 19.05 11.9956C19.0508 11.6422 18.9148 11.3113 18.6672 11.0635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightNav);
export default __webpack_public_path__ + "static/media/rightNav.fca7902279658d3af26805c0e13095fb.svg";
export { ForwardRef as ReactComponent };